import React, { useState } from 'react';
import { Button, Row, Col, Form, Spinner } from 'react-bootstrap';
import { PatientServices } from '../../../services/PatientService';

const OtherConditionsDetailsCard = ({ 
  patientDetails, 
  hospitalId, 
  showAlert 
}) => {
  const [otherConditionsData, setOtherConditionsData] = useState({
    diagnosis: '',
    notes: ''
  });

  const [submitLoading, setSubmitLoading] = useState(false);

  const handleOtherConditionsDataChange = (field, value) => {
    setOtherConditionsData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleOtherConditionsSubmit = async () => {
    try {
      setSubmitLoading(true);
      
      const submitData = {
        patientId: patientDetails.id,
        hospitalId: hospitalId,
        diagnosisType: 'otherConditions',
        ...otherConditionsData
      };

      console.log('Submitting Other Conditions data:', submitData);
      
      // TODO: Replace with actual API call
      // const response = await PatientServices.updatePatientDiagnosis(submitData);
      
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      showAlert('Success', 'Other Conditions diagnosis updated successfully!', 'success');
    } catch (error) {
      console.error('Error submitting other conditions data:', error);
      showAlert('Error', 'Failed to update other conditions diagnosis. Please try again.', 'danger');
    } finally {
      setSubmitLoading(false);
    }
  };

  return (
    <>
      <Row className="mb-3">
        <Col md={6}>
          <Form.Label style={{ fontWeight: 'bold' }}>Diagnosis :</Form.Label>
          <Form.Control
            type="text"
            value={otherConditionsData.diagnosis}
            onChange={(e) => handleOtherConditionsDataChange('diagnosis', e.target.value)}
            placeholder="Enter diagnosis"
          />
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={12}>
          <Form.Label style={{ fontWeight: 'bold' }}>Notes :</Form.Label>
          <Form.Control
            as="textarea"
            rows={4}
            value={otherConditionsData.notes}
            onChange={(e) => handleOtherConditionsDataChange('notes', e.target.value)}
            placeholder="Enter additional notes"
          />
        </Col>
      </Row>

      {/* Submit Button */}
      <Row className="mt-4">
        <Col className="d-flex justify-content-end">
          <Button 
            variant="success" 
            onClick={handleOtherConditionsSubmit}
            disabled={submitLoading || !otherConditionsData.diagnosis}
            style={{ 
              padding: '0.5rem 2rem',
              fontSize: '1rem'
            }}
          >
            {submitLoading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                Submitting...
              </>
            ) : (
              'Submit'
            )}
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default OtherConditionsDetailsCard;
